import React, { useEffect, useState } from 'react'
import CenteredInfoSection from '../CenteredInfoSection'

// Builder.io dependencies
import { Builder, BuilderComponent, builder } from '@builder.io/react'
import { useIsUSCountry } from 'hooks'

const PartnershipOffer = ({ ...rest }) => {
  const [partnershipOffers, setPartnershipOffers] = useState(null)

  const isUSA = useIsUSCountry()

  useEffect(() => {
    builder
      .get('partnership-offers', {
        userAttributes: {
          urlPath: '/signed-out-hp-partnership-offers'
        }
      })
      .toPromise()
      .then((partnershipOfferSection) =>
        setPartnershipOffers(partnershipOfferSection)
      )
  }, [])

  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
    >
      <CenteredInfoSection {...rest} />
      <BuilderComponent
        model='partnership-offers'
        content={partnershipOffers}
        data={{ isUSA }}
      />
    </div>
  )
}

export default PartnershipOffer
